import type { TCompany, ICompanyFilter } from "./types";
import {
  createPathParamCRUD,
  getAllPathParam,
  getPaginatedFilteredPathParam,
  type NoPathParams,
} from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "practice/company";
const SEARCH_SLUG = `${SLUG}/search`;

type TCompanySegmentPathParams = { type?: string };

export default createService(SLUG, {
  ...createPathParamCRUD<TCompany, NoPathParams, ICompanyFilter>(SLUG, SEARCH_SLUG),

  getAllByType: getAllPathParam<TCompany, TCompanySegmentPathParams, ICompanyFilter>(
    `${SLUG}/{type}`,
    `${SEARCH_SLUG}/{type}`
  ),

  getAllByTypePaginated: getPaginatedFilteredPathParam<
    TCompany,
    TCompanySegmentPathParams,
    ICompanyFilter
  >(`${SLUG}/{type}`, `${SEARCH_SLUG}/{type}`),
});
